// Helper functions for ReservationNightTable
import { format, parse } from "date-fns"

import { inchesToFeetAndInches } from "src/utils/UnitConversion"

export const formatDate = (dateString) => {
  if (!dateString) return ""

  // Parse YYYY-MM-DD date string without timezone conversion
  return format(parse(dateString, "yyyy-MM-dd", new Date()), "MM/dd/yyyy")
}

export const formatDateShort = (dateString) => {
  if (!dateString) return ""

  // Parse YYYY-MM-DD date string without timezone conversion
  return format(parse(dateString, "yyyy-MM-dd", new Date()), "MMM d")
}

export const formatDimension = (inches) => {
  if (!inches || inches === 0) return ""

  const { feet, inches: remainingInches } = inchesToFeetAndInches(inches)

  if (feet === 0) {
    return `${remainingInches}"`
  } else if (remainingInches === 0) {
    return `${feet}'`
  } else {
    return `${feet}' ${remainingInches}"`
  }
}
